{
  "chart": {
    "empty": {
      "description": "Keine Daten für diesen Zeitraum verfügbar.",
      "title": "Keine Daten gefunden"
    }
  },
  "date_picker": {
    "all_time": "Alle Zeiten",
    "confirm": "Bestätigen",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Letzte {days} Tage",
    "last_n_months": "Letzte {months} Monate",
    "today": "Heute"
  },
  "document_viewer": {
    "sidebar_heading": "Inhaltsübersicht"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "error": {
    "title": "Ein Fehler ist aufgetreten."
  },
  "gauge_chart": {
    "empty": {
      "title": "Keine Daten verfügbar",
      "tooltip": "Dein Resilienz-Score wird berechnet"
    }
  },
  "locale": {
    "current": "Deutsch",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Weiter mit {provider}"
  },
  "search": {
    "no_options": "Keine verfügbaren Optionen.",
    "no_results": "Keine Ergebnisse gefunden.",
    "placeholder": "suchen..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Vorschau schließen",
      "open": "Vorschau erweitern"
    }
  },
  "video_player": {
    "captions": "Untertitel",
    "captions_off": "Aus",
    "normal_speed": "Normal",
    "playback_speed": "Wiedergabegeschwindigkeit"
  }
}
